module.exports = __webpack_public_path__ + "img/d1af359a3070e70eb1e5df2384f9cc00.b341958a.png";